module.exports = __webpack_public_path__ + "static/avatar-tom-fb1eb1c3062981d2b7e0af1e997c6a7d.png";